import moment from 'moment';
import strings from '../localization';
import paths from '../../constants/paths';
import { capitalizeEachWord } from './utils';

const MAILING_ID_TIME_PERIOD = 1000 * 60 * 20;

export function formatPrice(number) {
  return parseFloat(number).toFixed(2);
}

export function getPricePerDay(period, periodUnit, totalPrice) {
  const currentTotalPrice = !totalPrice ? '0' : totalPrice;
  const days = moment.duration(parseInt(period, 10), periodUnit).days();
  const price = parseFloat(currentTotalPrice);
  const dailyPrice = price / days;
  return '$' + formatPrice(dailyPrice);
}

function formatPriceBetter(currency, price) {
  let priceStr = parseFloat(price).toFixed(2);
  let currencySymbol;
  let symbolFirst;
  let formatedPrice;

  switch (currency) {
    case 'USD':
    case 'CAD':
    case 'AUD':
      // eslint-disable-next-line quotes
      currencySymbol = `\u0024`;
      symbolFirst = true;
      formatedPrice = `\u0024${priceStr}`;
      break;
    case 'GBP':
      // eslint-disable-next-line quotes
      currencySymbol = `\u00A3`;
      symbolFirst = true;
      formatedPrice = `\u00A3${priceStr}`;
      break;
    // comma is fractional separator, decimal is thousand separator
    case 'EUR':
      priceStr = priceStr.replace('.', ',');
      // eslint-disable-next-line quotes
      currencySymbol = `\u20AC`;
      symbolFirst = true;
      formatedPrice = `\u20AC${priceStr}`;
      break;
    default:
      priceStr = priceStr.replace('.', ',');
      currencySymbol = currency;
      symbolFirst = false;
      formatedPrice = `${priceStr} ${currency}`;
      break;
  }

  return { priceStr, currencySymbol, symbolFirst, formatedPrice };
}

// temporary fix
// function sortManuallySubscriptions (subscriptions) {
//   const newArr = [0, 1, 2];
//   subscriptions.forEach(sub => {
//     if (sub.subscription_id === '3month21082018') {
//       newArr[1] = sub;
//     } else if (sub.subscription_id === '5daytrial') {
//       newArr[0] = sub;
//     } else if (sub.subscription_id === '1month21082018') {
//       newArr[2] = sub;
//     }
//   });
//   return newArr;
// }

export function prepareSubscriptionList(list) {
  // temporary fix sort subscriptions
  // const newList = sortManuallySubscriptions(list);
  // return newList.map(item => {
  const newList = list.map((item) => {
    if (!item) {
      return null;
    }

    const monthPrice = (
      Math.round((item.currency_price / item.rebill_period) * 100) / 100
    ).toFixed(2);
    const formatedMonthPrice = formatPriceBetter(
      item.currency_code,
      monthPrice
    ).formatedPrice;
    let rebilDate;
    let formatedTrialPrice = null;

    if (item.trial_period_enabled) {
      rebilDate = moment()
        .add(item.trial_period, `${item.trial_period_unit}s`)
        .format('MMM D YYYY');
      formatedTrialPrice = formatPriceBetter(
        item.currency_code,
        item.currency_trial_price
      ).formatedPrice;
    } else {
      rebilDate = moment()
        .add(item.rebill_period, 'months')
        .format('MMM D YYYY');
    }

    const formatedPriceObj = formatPriceBetter(
      item.currency_code,
      item.currency_price
    );

    return {
      price_hint: item.price_hint,
      isPrimary: item.primary,
      subscription_id: item.subscription_id,
      product_id: item.product_id,
      months: item.rebill_period * 1,
      rebill_every_days: item.rebill_period * 30,
      month_price: monthPrice,
      formatedMonthPrice,
      trial_period_enabled: item.trial_period_enabled,
      trial_period: item.trial_period,
      trial_period_unit: item.trial_period_unit,
      trial_price: item.currency_trial_price,
      rebilDate,
      currency_price: item.currency_price,
      currency_trial_price: item.currency_trial_price,
      currency_code: item.currency_code,
      rebill_period: item.rebill_period,
      basePrice: item.price,
      priceStr: formatedPriceObj.priceStr,
      formatedPrice: formatedPriceObj.formatedPrice,
      formatedTrialPrice,
      currencySymbol: formatedPriceObj.currencySymbol,
      currencySymbolFirst: formatedPriceObj.symbolFirst,
      stepdown:
        item.stepdown.length > 0 ? prepareSubscriptionList(item.stepdown) : [],
      initial_offer_promo:
        item.initial_offer_promo &&
        Object.keys(item.initial_offer_promo).length > 0
          ? preparePromoSubscription(item.initial_offer_promo)
          : {},
    };
  });

  return sortSubscriptions(newList);
}

// just make sure primary is 2-nd one
export function sortSubscriptions(subs) {
  let newSubs = [];
  if (subs.length === 3 && subs[0].isPrimary) {
    newSubs.push(subs[1]);
    newSubs.push(subs[0]);
    newSubs.push(subs[2]);
  } else if (subs.length === 3 && subs[2].isPrimary) {
    newSubs.push(subs[0]);
    newSubs.push(subs[2]);
    newSubs.push(subs[1]);
  } else {
    newSubs = [...subs];
  }
  return newSubs;
}

export function prepareHeaderAndSubHeader(
  fromWhere,
  counters,
  userHash = null
) {
  let headerText;
  let subHeaderText;
  let additionalText = '';
  let counter = 0;

  switch (fromWhere) {
    case 'likes-me':
      if (counters.unseen_liked_me > 1) {
        headerText = strings.peopleLikedYou;
        subHeaderText = strings.chooseVipPlanToSeeThem;
        counter = counters.unseen_liked_me;
      } else {
        headerText = strings.wantToSeeWhoLikesYou;
        subHeaderText = strings.upgradeToVipChoosePlan;
      }
      break;
    case 'undo':
      headerText = strings.needToUndoMistake;
      subHeaderText = strings.getUnlimitedUndos;
      break;
    case 'viewed-me':
      if (counters.unseen_viewed_me > 1) {
        headerText = strings.peopleViewedYourProfile;
        subHeaderText = strings.chooseVipPlanToSeeThem;
        counter = counters.unseen_viewed_me;
      } else {
        headerText = strings.whoViewedYourProfile;
        subHeaderText = strings.upgradeToVipChoosePlan;
      }
      break;
    case 'favorited-me':
      if (counters.unseen_favorited_me > 1) {
        headerText = strings.peopleFavoritedYou;
        subHeaderText = strings.chooseVipPlanToSeeThem;
        counter = counters.unseen_favorited_me;
      } else {
        headerText = strings.wantToSeeWhoFavoritedYou;
        subHeaderText = strings.upgradeToVipChoosePlan;
      }
      break;
    case 'chat':
      if (userHash) {
        headerText = strings.unlimitedMessaging;
        subHeaderText = strings.toPremiumUsers;
        additionalText = strings.upgradeTodayAndSendMessage;
      } else {
        headerText = strings.youAreBasic;
        subHeaderText = strings.upgradeToVipChoosePlan;
      }
      break;
    case 'membership':
      headerText = strings.youAreBasic;
      subHeaderText = strings.upgradeToVipChoosePlan;
      break;
    case 'see-all-photos':
      if (userHash) {
        headerText = strings.accessToAllPhotos;
        subHeaderText = strings.toPremiumUsers;
        additionalText = strings.upgradeTodayAndSeePhotos;
      } else {
        headerText = strings.youAreBasic;
        subHeaderText = strings.upgradeToVipChoosePlan;
      }
      break;
    case 'flirts':
      headerText = strings.wantMoreFlirts;
      subHeaderText = strings.upgradeToVipChoosePlan;
      break;
    case 'show_initial_upgrade':
      headerText = strings.meetSomeoneTonight;
      subHeaderText = strings.chooseVipPlanBelow;
      break;
    case 'visibility-preferences':
      headerText = strings.goPrivateSub;
      subHeaderText = strings.upgradeToVipChoosePlan;
      break;
    default:
      headerText = strings.youAreBasic;
      subHeaderText = strings.upgradeToVipChoosePlan;
      counter = 0;
      break;
  }

  return { headerText, subHeaderText, counter, additionalText };
}

export function getHeadersTextForSubscription(sub) {
  let saveText,
    priceText,
    moText,
    headerText,
    subHeaderText,
    subHeaderTextSecond,
    isPrimary;
  let subscriptionCheckoutHeader,
    subscriptionCheckoutSubHeader,
    subscriptionCheckoutRadioHeader,
    subscriptionCheckoutRadioSubHeader;
  let bottomText = '';

  if (!sub.trial_period_enabled) {
    if (sub.months === 1) {
      saveText = sub.price_hint;
      priceText = `${sub.month_price}`;
      moText = `/${strings.mo}`;
      headerText = `${sub.months} ${strings.monthFor}`;
      subHeaderText = `${sub.formatedPrice} ${strings.billed}`;
      subHeaderTextSecond = `${strings.every} ${strings.month}`;
      isPrimary = sub.isPrimary;
      subscriptionCheckoutHeader = `${headerText} ${strings.for} ${priceText}${moText}`;
      subscriptionCheckoutSubHeader = `${subHeaderText} ${subHeaderTextSecond}`;
      subscriptionCheckoutRadioHeader = subscriptionCheckoutHeader;
      subscriptionCheckoutRadioSubHeader = subscriptionCheckoutSubHeader;
    } else {
      saveText = sub.price_hint;
      priceText = `${sub.month_price}`;
      moText = `/${strings.mo}`;
      headerText = `${sub.months} ${strings.monthsFor}`;
      subHeaderText = `${sub.formatedPrice} ${strings.billed}`;
      subHeaderTextSecond = `${strings.every} ${sub.months} ${strings.months}`;
      isPrimary = sub.isPrimary;
      subscriptionCheckoutHeader = `${headerText} ${strings.for} ${priceText}${moText}`;
      subscriptionCheckoutSubHeader = `${subHeaderText} ${subHeaderTextSecond}`;
      subscriptionCheckoutRadioHeader = subscriptionCheckoutHeader;
      subscriptionCheckoutRadioSubHeader = subscriptionCheckoutSubHeader;
    }
  } else {
    const formatedPriceObj = formatPriceBetter(
      sub.currency_code,
      sub.trial_price
    );
    saveText = sub.price_hint;
    const pricePerDay = formatPrice(sub.trial_price);
    const ext = sub.trial_price ? `${pricePerDay}` : strings.free;
    priceText = `${ext}`;
    headerText = `${sub.trial_period} ${capitalizeEachWord(
      sub.trial_period_unit
    )} ${strings.trial} `;
    const firstPart = `${formatedPriceObj.formatedPrice} ${sub.trial_period}`;
    const secondPart = `${capitalizeEachWord(sub.trial_period_unit)} ${
      strings.trialRebillsAt
    }`;
    bottomText = `${sub.formatedPrice} ${strings.per} ${sub.months} ${strings.month}`;
    subHeaderText = `${firstPart} ${secondPart}`;
    isPrimary = sub.isPrimary;
    const subHeaderExt1 = `${sub.trial_period} ${
      sub.trial_period > 1 ? strings.days : capitalizeEachWord(strings.day)
    }`;
    const subHeaderExt2 = ` ${strings.for} $${sub.trial_price}`;
    subscriptionCheckoutHeader = `${subHeaderExt1}${subHeaderExt2}`;
    subscriptionCheckoutSubHeader = `$${sub.trial_price} ${strings.trialRebillsAt} ${sub.month_price}/${strings.mo}`;

    subscriptionCheckoutRadioHeader = `${headerText} ${
      strings.for
    } $${formatPrice(+sub.trial_price / sub.trial_period)}/${strings.day}`;
    subscriptionCheckoutRadioSubHeader = `${subHeaderText} ${bottomText}`;
  }

  return {
    saveText,
    priceText,
    moText,
    headerText,
    subHeaderText,
    subHeaderTextSecond,
    bottomText,
    isPrimary,
    subscriptionCheckoutHeader,
    subscriptionCheckoutSubHeader,
    subscriptionCheckoutRadioHeader,
    subscriptionCheckoutRadioSubHeader,
  };
}

export function maskCC(number) {
  if (number && number.length > 4) {
    number = number.replace(/.(?=.{4})/g, 'x');
    number = number.match(/.{4}/g).join('-');
  }
  return number;
}

export function setRouteToReturn(route, memberHash = null) {
  // console.log('UPGRADE HELPRER::', route, memberHash);
  if (memberHash == null) {
    const queryMatches = route.match(/flirt\.(.*)/);
    if (queryMatches && queryMatches.length > 0) {
      route = 'flirt-user';
      memberHash = queryMatches[1];
    }

    const photosMatches = route.match(/photos\.(.*)/);
    if (photosMatches && photosMatches.length > 0) {
      return `/member/${photosMatches[1]}/photos`;
    }
  }

  if (
    route === paths.LIKES__ME ||
    route === paths.FAVORITES__ME ||
    route === paths.VIEWED__ME
  ) {
    return route;
  }

  switch (route) {
    case 'likes-me':
    case 'likes-profile.me':
      return paths.LIKES__ME;
    case 'viewed-me':
    case 'viewed-profile.me':
      return paths.VIEWED__ME;
    case 'favorited-me':
      return paths.FAVORITES__ME;
    case 'chat':
      return `/chat/${memberHash}`;
    case 'membership':
      return paths.SETTINGS;
    case 'see-all-photos':
    case 'flirts':
      return `/member/${memberHash}`;
    case 'flirt-user':
      return `/flirt-user/${memberHash}`;
    case 'undo':
      return paths.QUICK_MATCH;
    case 'show_initial_upgrade':
      return paths.MATCHES;
    case 'visibility-preferences':
      return paths.SETTINGS;
    default:
      return paths.MATCHES;
  }
}

export function preparePromoSubscription(item) {
  let navbarTitle;
  let headerText;
  let subHeaderText;
  let buttonText;
  let rebilDate;
  let formatedTrialPrice = null;
  let formatedPrice = null;

  if (item.currency_trial_price) {
    formatedTrialPrice = formatPriceBetter(
      item.currency_code,
      item.currency_trial_price
    ).formatedPrice;
  }

  if (item.promo_title && item.promo_title !== '') {
    navbarTitle = item.promo_title;
  } else {
    navbarTitle = strings.limitedTimeOffer;
  }

  if (item.promo_desc && item.promo_desc !== '') {
    headerText = item.promo_desc;
  } else if (!item.trial_period_enabled) {
    formatedPrice = formatPriceBetter(
      item.currency_code,
      item.price
    ).formatedPrice;
    headerText = strings.formatString(strings.promoHeaderNoTrial, {
      price: `${formatedPrice}`,
      rebill_period: `${item.rebill_period}`,
    });
  } else {
    headerText = strings.formatString(strings.promoHeader, {
      date: `${item.trial_period} ${capitalizeEachWord(
        item.trial_period_unit
      )}`,
      price: `${formatedTrialPrice}`,
    });
  }

  if (item.promo_desc2 && item.promo_desc2 !== '') {
    subHeaderText = item.promo_desc2;
  } else {
    subHeaderText = strings.promoSubHeaderText;
  }

  if (item.promo_cta && item.promo_cta !== '') {
    buttonText = item.promo_cta;
  } else {
    buttonText = strings.formatString(strings.promoButtonText, {
      price: `${formatedTrialPrice}`,
      date: `${item.trial_period} ${capitalizeEachWord(
        item.trial_period_unit
      )}`,
    });
  }

  if (item.trial_period_enabled) {
    rebilDate = moment()
      .add(item.trial_period, `${item.trial_period_unit}s`)
      .format('MMM D YYYY');
  } else {
    rebilDate = moment().add(item.rebill_period, 'months').format('MMM D YYYY');
  }

  const rebillText = strings.formatString(strings.promoRebillsText, {
    date: `${item.rebill_period} month`,
    price: `${item.currency_price}`,
  });
  const monthPrice = (
    Math.round((item.currency_price / item.rebill_period) * 100) / 100
  ).toFixed(2);
  const formatedMonthPrice = formatPriceBetter(
    item.currency_code,
    monthPrice
  ).formatedPrice;
  const formatedPriceObj = formatPriceBetter(
    item.currency_code,
    item.currency_price
  );

  return {
    id: item.id,
    price_hint: item.price_hint,
    subscription_id: item.subscription_id,
    product_id: item.product_id,
    months: item.rebill_period * 1,
    rebill_period: item.rebill_period,
    rebill_every_days: item.rebill_period * 30,
    month_price: monthPrice,
    formatedMonthPrice,
    trial_period_enabled: item.trial_period_enabled,
    trial_period: item.trial_period,
    trial_period_unit: item.trial_period_unit,
    trial_price: item.trial_price,
    total_raw_price: 12 * monthPrice,
    soft_expiration: item.soft_expiration,
    price: item.price,
    currency_price: item.currency_price,
    currency_trial_price: item.currency_trial_price,
    currency_code: item.currency_code,
    priceStr: formatedPriceObj.priceStr,
    formatedPrice: formatedPriceObj.formatedPrice,
    formatedTrialPrice,
    currencySymbol: formatedPriceObj.currencySymbol,
    currencySymbolFirst: formatedPriceObj.symbolFirst,
    rebilDate,
    navbarTitle,
    headerText,
    subHeaderText,
    buttonText,
    rebillText,
    stepdown: item.stepdown,
  };
}

function getMailingIdFromStorage() {
  const mailingId = localStorage.getItem('__MAILING_ID__');
  if (mailingId !== null) {
    return JSON.parse(mailingId);
  } else {
    return {};
  }
}

export function checkMailingId(id) {
  const currentMailingId = getMailingIdFromStorage();
  const currentTimestamp = Date.now();
  const obj = { mailingId: id, isExpired: false, timestamp: currentTimestamp };

  if (Object.keys(currentMailingId).length > 0) {
    if (currentMailingId.mailingId === id) {
      if (
        currentTimestamp - currentMailingId.timestamp >
        MAILING_ID_TIME_PERIOD
      ) {
        obj.isExpired = true;
        obj.timestamp = currentMailingId.timestamp;
      } else {
        obj.timestamp = currentMailingId.timestamp;
      }
    }
  }

  return obj;
}

export function saveMailingIdToStorage(id) {
  const mailingIdObj = checkMailingId(id);
  localStorage.setItem('__MAILING_ID__', JSON.stringify(mailingIdObj));
}
